export default __webpack_public_path__ + "static/media/ic.da3b6c39.svg";